import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';

// Default set used for every activity until UX provides per-activity images.
const DEFAULT_IMAGES = [
    {
      "id": "photo-2826",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-advisor-1-1024x1024.png",
      "width": 1024,
      "height": 1024
    },
    {
      "id": "photo-2827",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-advisor-2-1024x1024.png",
      "width": 1024,
      "height": 1024
    },
    {
      "id": "photo-2842",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-internship-host-1-1024x576.png",
      "width": 1024,
      "height": 576
    }
];

/**
 * Per-activity image sets, keyed by the activity (tag) name.
 * Get images from WordPress like this:
 *
 * http https://www.communityshare.org/wp-json/wp/v2/media/ \
 * search=="project-share-workshop" \
 * orderby==title order==asc \
 * |jq '[.[] | {id: ("photo-" + (.id | tostring)), src: .media_details.sizes.large.source_url, width:
 * .media_details.sizes.large.width, height: .media_details.sizes.large.height}]'
 */
const IMAGES_BY_ACTIVITY = {
  "Advisor": [
    {
      "id": "photo-2826",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-advisor-1-1024x1024.png",
      "width": 1024,
      "height": 1024
    },
    {
      "id": "photo-2827",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-advisor-2-1024x1024.png",
      "width": 1024,
      "height": 1024
    },
    {
      "id": "photo-2842",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-internship-host-1-1024x576.png",
      "width": 1024,
      "height": 576
    }
  ],
  "Challenge": [
    {
      "id": "photo-2829",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-challenge-1-1024x576.png",
      "width": 1024,
      "height": 576
    },
    {
      "id": "photo-2830",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-challenge-2-1024x576.png",
      "width": 1024,
      "height": 576
    },
    {
      "id": "photo-2831",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-challenge-3-1024x576.png",
      "width": 1024,
      "height": 576
    }
  ],
  "Competition": [
    {
      "id": "photo-2832",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-competition-1-1024x576.png",
      "width": 1024,
      "height": 576
    },
    {
      "id": "photo-2833",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-competition-2-1024x576.png",
      "width": 1024,
      "height": 576
    },
    {
      "id": "photo-2834",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-competition-3-1024x576.png",
      "width": 1024,
      "height": 576
    }
  ],
  "Demonstration": [
    {
      "id": "photo-2835",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-demonstration-1-1024x576.png",
      "width": 1024,
      "height": 576
    },
    {
      "id": "photo-2837",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-demonstration-2-1024x576.png",
      "width": 1024,
      "height": 576
    },
    {
      "id": "photo-2838",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-demonstration-3-1024x576.png",
      "width": 1024,
      "height": 576
    }
  ],
  "Guest Instructor": [
    {
      "id": "photo-2839",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-guest-instructor-1-1024x576.png",
      "width": 1024,
      "height": 576
    },
    {
      "id": "photo-2840",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-guest-instructor-2-1024x576.png",
      "width": 1024,
      "height": 576
    },
    {
      "id": "photo-2841",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-guest-instructor-3-1024x576.png",
      "width": 1024,
      "height": 576
    }
  ],
  "Internship Host": [
    {
      "id": "photo-2842",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-internship-host-1-1024x576.png",
      "width": 1024,
      "height": 576
    },
    {
      "id": "photo-2843",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-internship-host-2-1024x576.png",
      "width": 1024,
      "height": 576
    },
    {
      "id": "photo-2844",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-internship-host-3-1024x576.png",
      "width": 1024,
      "height": 576
    }
  ],
  "Interview": [
    {
      "id": "photo-2845",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-interview-1-1024x576.png",
      "width": 1024,
      "height": 576
    },
    {
      "id": "photo-2846",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-interview-2-1024x576.png",
      "width": 1024,
      "height": 576
    },
    {
      "id": "photo-2847",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-interview-3-1024x576.png",
      "width": 1024,
      "height": 576
    }
  ],
  "Job Shadow": [
    {
      "id": "photo-2848",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-job-shadow-1-1024x576.png",
      "width": 1024,
      "height": 576
    },
    {
      "id": "photo-2849",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-job-shadow-2-1024x576.png",
      "width": 1024,
      "height": 576
    },
    {
      "id": "photo-2864",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-tutor-1-1024x576.png",
      "width": 1024,
      "height": 576
    }
  ],
  "Mentor": [
    {
      "id": "photo-2852",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-mentor-1-1024x576.png",
      "width": 1024,
      "height": 576
    },
    {
      "id": "photo-2853",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-mentor-2-1024x576.png",
      "width": 1024,
      "height": 576
    },
    {
      "id": "photo-2854",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-mentor-3-1024x576.png",
      "width": 1024,
      "height": 576
    }
  ],
  "Performance": [
    {
      "id": "photo-2855",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-performance-1-1024x576.png",
      "width": 1024,
      "height": 576
    },
    {
      "id": "photo-2856",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-performance-2-1024x576.png",
      "width": 1024,
      "height": 576
    },
    {
      "id": "photo-2857",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-performance-3-1024x576.png",
      "width": 1024,
      "height": 576
    }
  ],
  "Speaker": [
    {
      "id": "photo-2858",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-speaker-1-1024x576.png",
      "width": 1024,
      "height": 576
    },
    {
      "id": "photo-2859",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-speaker-2-1024x576.png",
      "width": 1024,
      "height": 576
    },
    {
      "id": "photo-2860",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-speaker-3-1024x576.png",
      "width": 1024,
      "height": 576
    }
  ],
  "Tour": [
    {
      "id": "photo-2861",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-tour-1-1024x576.png",
      "width": 1024,
      "height": 576
    },
    {
      "id": "photo-2862",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-tour-2-1024x576.png",
      "width": 1024,
      "height": 576
    },
    {
      "id": "photo-2863",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-tour-3-1024x576.png",
      "width": 1024,
      "height": 576
    }
  ],
  "Tutor": [
    {
      "id": "photo-2864",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-tutor-1-1024x576.png",
      "width": 1024,
      "height": 576
    },
    {
      "id": "photo-2865",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-tutor-2-1024x576.png",
      "width": 1024,
      "height": 576
    },
    {
      "id": "photo-2866",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-tutor-3-1024x576.png",
      "width": 1024,
      "height": 576
    }
  ],
  "Workshop": [
    {
      "id": "photo-2867",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-workshop-1-1024x576.png",
      "width": 1024,
      "height": 576
    },
    {
      "id": "photo-2868",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-workshop-2-1024x576.png",
      "width": 1024,
      "height": 576
    },
    {
      "id": "photo-2869",
      "src": "https://www.communityshare.org/wp-content/uploads/2026/06/project-share-workshop-3-1024x576.png",
      "width": 1024,
      "height": 576
    }
  ],
};

/**
 * Preview images a project can share, chosen by the project's activity.
 * Falls back to the default set while the activity is loading or when an
 * activity has no dedicated images.
 *
 * @param {number} [activityId] - project.data.activityId
 * @returns {{ loading: boolean, images: Array<{ id: string, src: string, width: number, height: number }> }}
 */
export default function usePreviewImages(activityId) {
  // Default to tag 1 so byId never throws for projects without an activity
  const activity = useConnect('tag.byId', {
    id: activityId ?? 1
  });

  return {
    loading: activity.state === PayloadStates.FETCHING,
    images: IMAGES_BY_ACTIVITY[activity?.data?.name] ?? DEFAULT_IMAGES
  };
}
